import { ActionModal, Dialog, DialogPosition, Typography } from '@ecdlink/ui';
import { useState } from 'react';
import IconRobot from '@/assets/svg-components/iconRobot';
import IconRobotBlue from '@/assets/svg-components/iconRobotBlue';
import { UserFlagKeys } from '@ecdlink/core';
import { useUserFlag } from '@/hooks/useUserFlag';
import { useAppContext } from '@/walkthrougContext';
import { WalkthroughModal } from '@/components/walkthrough/modal';

export const StatementsWalkthroughStart = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const [isSkipped, setIsSkipped] = useState(false);
  const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
  const [, completeStatementsWalkthrough] = useUserFlag(
    UserFlagKeys.incomeStatementsWalkthroughComplete
  );

  const { setState } = useAppContext();

  if (isLanguageModalOpen) {
    return (
      <Dialog visible position={DialogPosition.Middle} className="p-4">
        <WalkthroughModal
          onStart={() => {
            completeStatementsWalkthrough();
            setState({ run: true, tourActive: true, stepIndex: 0 });
            onClose();
          }}
        />
      </Dialog>
    );
  }

  if (isSkipped) {
    return (
      <Dialog visible position={DialogPosition.Bottom} className="p-4">
        <ActionModal
          customIcon={
            <div className="flex">
              <IconRobot className="mb-2 mr-6 h-24 w-24" />
              <Typography
                text="Ok, you can always get help by tapping the question mark at the top of the screen!"
                type="body"
                color="textDark"
              />
            </div>
          }
          iconColor="alertMain"
          iconBorderColor="alertBg"
          actionButtons={[
            {
              text: 'Close',
              textColour: 'white',
              colour: 'quatenary',
              type: 'filled',
              onClick: () => {
                completeStatementsWalkthrough();
                onClose();
              },
              leadingIcon: 'XIcon',
            },
          ]}
        />
      </Dialog>
    );
  }

  return (
    <Dialog visible position={DialogPosition.Middle} className="p-4">
      <ActionModal
        customIcon={<IconRobotBlue className="mb-4" />}
        title="Manage your business like a boss!"
        detailText="Would you like to see how to create your income statements?"
        actionButtons={[
          {
            type: 'filled',
            colour: 'quatenary',
            text: 'Yes, help me!',
            textColour: 'white',
            leadingIcon: 'CheckCircleIcon',
            onClick: () => setIsLanguageModalOpen(true),
          },
          {
            type: 'outlined',
            colour: 'quatenary',
            text: 'No, skip!',
            textColour: 'quatenary',
            leadingIcon: 'ClockIcon',
            onClick: () => {
              setIsSkipped(true);
            },
          },
        ]}
      />
    </Dialog>
  );
};
